/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EmployeePostClassStudentViewModel } from "../types/EmployeePostClassStudentViewModel.ts";

export const employeePostClassStudentViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  employeePostId: z.optional(z.number().int()),
  classStudentId: z.optional(z.number().int()),
  classStudentName: z.string().nullish(),
  code: z.string().nullish(),
  courseName: z.string().nullish(),
}) as unknown as ToZod<EmployeePostClassStudentViewModel>;
